import { useContext } from "react"

import { StylingParametersContext } from "./stylingParametersProvider"

export const useGetStylingParametersContext = () => {
  const context = useContext(StylingParametersContext)
  if (!context) {
    throw new Error(
      "useGetTranslationsContext must be used within a TranslationsProvider"
    )
  }
  return context
}
